export default {
    api_base: "/backend",
    dev_base: "http://localhost:8095",
    dev_attachment_url: "http://localhost:8095/attachment/",
}